export enum IceRangesColorCodesEnum {
    RANGE_80_100 = '#00b050',
    RANGE_60_79 = '#c4d6a0',
    RANGE_40_59 = '#ffff99',
    RANGE_20_39 = '#ffcc99',
    RANGE_0_19 = '#ff8080',
}
